import React from 'react';
import { Dropdown, DropdownItem, DropdownToggle, DropdownMenu,
  Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import ConversionForm from './ConversionForm';
import CONVERSIONS from '../constants/conversions';
import { CONVERTABLE } from '../constants/Fixtures';
import { mergedSettings } from '../helpers/SettingsHelpers';

// need to clarify the relationship of this component to ConversionForm
export default class ConversionList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      condensed: true,
      dropdown: false,
    };
  }

  unrestrictedConversion(output) {
    if (output.toLowerCase().includes('epub') ){
      if (this.props.access === 'freelancer') {return false;}
    }
    if (output.toLowerCase() === 'pdf' ){
      if (this.props.access !== 'admin') {return false;}
    }
    return true;
  }

  availableConversions = () => CONVERSIONS.filter(conv => this.includedConversion(conv.input) &&
        this.unrestrictedConversion(conv.output))

  includedConversion = (input) => {
    if (!this.props.available) { return true; }
    return this.props.available.indexOf(input) > -1;
  }

  getSettings() {
    return mergedSettings(this.props.settings, this.props.org_settings);
  }

  sortedSettings = () => {
    const sorted = {};
    this.getSettings().map((sett) => {
      sett.conversions.map((conv) => {
        if (sorted[conv] !== undefined) {
          sorted[conv].push(sett);
        } else {
          sorted[conv] = [sett];
        }
      });
    });
    return sorted;
  }

  render() {
    const sortedS = this.sortedSettings();
    const conversions = this.availableConversions();
    return (<div className="conversion-container">
      {conversions.length > 0 ?
        <div className="conversion-list">
          <ConversionForm
            settings={sortedS}
            conversions={conversions}
            target={this.props.target}
            updateSettings={this.props.updateSettings}
            performConversion={this.props.performConversion}
          />
        </div>
        : <div className="alert alert-info" role="alert">
          Upload MS Word, InDesign XML, sam, or ScML files to access conversions.
        </div>
      }
    </div>);
  }
}
